import { AUTHENTICATING_HUBSPOT_REQUEST, AUTHENTICATING_HUBSPOT_SUCCEDDED, AUTHENTICATING_HUBSPOT_FAILED,
  UPDATING_HUBSPOT_REQUEST, UPDATING_HUBSPOT_SUCCEDDED, UPDATING_HUBSPOT_FAILED,
} from '../../actions/actionTypes.jsx';
import { AUTHENTICATING_SUITECRM_FAILED, DEACTIVATING_HUBSPOT_INTEGRATION, DEACTIVATING_HUBSPOT_INTEGRATION_FAILED, DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED, DELETING_SECONDARY_CONFIGURATION, DELETING_SECONDARY_CONFIGURATION_FAILED, DELETING_SECONDARY_CONFIGURATION_SUCCEEDED, FETCHING_HUBSPOT_INTEGRATION_REQUEST, FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED, FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED } from '../../actions/actionTypes';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  config: {
    loading: false,
    item: null,
    error: null
  },
  synchronisation: {
    synchronising: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  },
  integration: {},
  totalHubspotIntegrations: 0
};

function hubspotReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_HUBSPOT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })

    case AUTHENTICATING_HUBSPOT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })

    case AUTHENTICATING_SUITECRM_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      })

    case FETCHING_HUBSPOT_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true
      })
    
    case FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED:
      
      return Object.assign({}, state, {
        ...state,
          loading: false,
          integration: action.payload
      });

    case FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false
      });

    // case FETCHING_HUBSPOT_MASTER_CONFIG_REQUEST:
    //   return Object.assign({}, state, {
    //     ...state,
    //     config: {
    //       loading: true,
    //       error: null
    //     }
    //   })
    // case FETCHING_HUBSPOT_MASTER_CONFIG_SUCCEDDED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     config: {
    //       loading: false,
    //       item: action.payload,
    //       error: null
    //     }
    //   })
    // case FETCHING_HUBSPOT_MASTER_CONFIG_FAILED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     config: {
    //       loading: false,
    //       item: null,
    //       error: action.payload
    //     }
    //   }) 

    case UPDATING_HUBSPOT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_HUBSPOT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        },
        integration: action.payload
      })
    case UPDATING_HUBSPOT_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })

    // case SYNCHRONISING_HUBSPOT_REQUEST:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       synchronising: true,
    //       error: null
    //     }

    //   })
    // case SYNCHRONISING_HUBSPOT_SUCCEDDED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       synchronising: false,
    //       error: null
    //     }
    //   })
    // case SYNCHRONISING_HUBSPOT_FAILED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       synchronising: false,
    //       error: action.payload
    //     }
    //   })
    
    // case FETCHING_HUBSPOT_SYNC_DETAILS_REQUEST:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       error: null
    //     }

    //   })
    // case FETCHING_HUBSPOT_SYNC_DETAILS_SUCCEDDED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       synchronising: action.payload.syncInProgress,
    //       error: null
    //     }
    //   })
    // case FETCHING_HUBSPOT_SYNC_DETAILS_FAILED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     synchronisation: {
    //       error: action.payload
    //     }
    //   }) 

    case DELETING_SECONDARY_CONFIGURATION:
      return Object.assign({}, state, {
        ...state,
        deactivation: {
          ...state.deactivation,
          deactivating: true
        }
      })

    case DELETING_SECONDARY_CONFIGURATION_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        integration: action.payload,
        deactivation: {
          ...state.deactivation,
          deactivating: false
        },
      })

    case DELETING_SECONDARY_CONFIGURATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        deactivation: {
          ...state.deactivation,
          deactivating: false
        }
      })

    case DEACTIVATING_HUBSPOT_INTEGRATION:
      return Object.assign({}, state, {
        ...state,
        deactivation: {
          ...state.deactivation,
            deactivating: true
          } 
        })
    
    case DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        integration: {},
        deactivation: {
          ...state.deactivation,
            deactivating: false
          } 
      })

    case DEACTIVATING_HUBSPOT_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        deactivation: {
          ...state.deactivation,
            deactivating: false
          } 
      })

      case FETCHING_TOTAL_HUBSPOT_INTEGRATIONS:
        return Object.assign({}, state, {   
      })

      case FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED:
        return Object.assign({}, state, {
          ...state,
          totalHubspotIntegrations: action.payload
      })

      case FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED:
        return Object.assign({}, state, {
          error: action.payload
      })

     
    default:
      return state;
  }
}

export { hubspotReducer };